<div class="d-flex vw-100 vh-100">


  <app-main-layout-navbar></app-main-layout-navbar>
  <main role="main" class="main-content flex-grow-1 overflow-hidden">
    <router-outlet></router-outlet>
  </main>

</div>
